import request from "api/request2";
import { LeaveRequestsFilters, LeaveRequestsPaginatedResponse } from "./types";

const LEAVE_REQUESTS_MAINTAINER = {
  PAGINATED_DATA: "/leaves/paginated-requests",
  ALL_DATA: "/leaves/requests",
};

export function getPaginatedData(params?: LeaveRequestsFilters) {
  const searchParams = params?.searchParams || {};

  return request<LeaveRequestsPaginatedResponse>(
    LEAVE_REQUESTS_MAINTAINER.PAGINATED_DATA,
    {
      method: "GET",
      params: {
        ...searchParams,
        page: Math.max(params?.page ?? 1, 1),
        items_per_page: Math.max(params?.limit ?? 10, 1),
      },
    },
  );
}

export function getData(params?: LeaveRequestsFilters["searchParams"]) {
  const searchParams = params || {};

  return request<LeaveRequestsPaginatedResponse["data"]>(
    LEAVE_REQUESTS_MAINTAINER.ALL_DATA,
    {
      method: "GET",
      params: searchParams,
    },
  );
}

export function annulLeaveRequest(id: string, payload?: { comments?: string }) {
  return request(`/leaves/approvals/annul/${id}`, {
    method: "DELETE",
    data: payload,
  });
}
